import { Directive, ElementRef, Input, Renderer2, HostListener } from '@angular/core';

@Directive({
    standalone: true,
    selector: '[appImageError]'
})
export class ImageErrorDirective {
    @Input() errorImage: string = 'assets/shiva/shadow-user.jpg';

    constructor(private el: ElementRef, private renderer: Renderer2) { }

    @HostListener('error')
    onError() {
        this.renderer.setAttribute(this.el.nativeElement, 'src', this.errorImage);
    }
}